import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertPanel = ({ alerts, expanded = false }) => {
  const getSeverityBadge = (severity) => {
    const badges = {
      low: 'bg-muted text-muted-foreground',
      medium: 'bg-warning/10 text-warning',
      high: 'bg-error/10 text-error',
      critical: 'bg-error text-error-foreground'
    };
    return badges?.[severity] || badges?.low;
  };

  const getStatusBadge = (status) => {
    const badges = {
      active: 'bg-error/10 text-error',
      acknowledged: 'bg-warning/10 text-warning',
      investigating: 'bg-primary/10 text-primary',
      resolved: 'bg-success/10 text-success'
    };
    return badges?.[status] || badges?.active;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <Icon name="AlertTriangle" size={24} className="text-primary" />
          <h4 className="text-base font-semibold">Active Alerts</h4>
        </div>
        <span className="text-sm text-muted-foreground">{alerts?.length} active</span>
      </div>
      <div className="space-y-3">
        {alerts?.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <Icon name="CheckCircle2" size={48} className="mx-auto mb-2 text-success" />
            <p>No active alerts</p>
          </div>
        ) : (
          alerts?.map((alert) => (
            <div
              key={alert?.id}
              className="border border-border rounded-lg p-4 hover:bg-muted/50 transition-colors"
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${getSeverityBadge(alert?.severity)}`}>
                    {alert?.severity?.toUpperCase()}
                  </span>
                  <span className={`px-2 py-1 rounded text-xs font-medium ${getStatusBadge(alert?.status)}`}>
                    {alert?.status?.toUpperCase()}
                  </span>
                </div>
                <span className="text-xs text-muted-foreground">{alert?.timestamp}</span>
              </div>
              <h5 className="font-medium mb-1">{alert?.title}</h5>
              <p className="text-sm text-muted-foreground mb-2">{alert?.description}</p>
              {expanded && (
                <>
                  <div className="flex items-center gap-2 mb-3">
                    <Icon name="Server" size={14} className="text-muted-foreground" />
                    <span className="text-xs text-muted-foreground">
                      Affected: {alert?.affectedServices?.join(', ')}
                    </span>
                  </div>
                  <div className="flex gap-2">
                    <Button size="sm" variant="outline">
                      Acknowledge
                    </Button>
                    <Button size="sm" variant="outline">
                      View Details
                    </Button>
                  </div>
                </>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AlertPanel;